import MicroModal from 'micromodal';
import Cookies from 'js-cookie';

class Modal {
  constructor() {
    Modal.init();
  }

  static init() {
    const videoModalLink = document.querySelectorAll('[data-target="modal-video"]');
    const popupModal = this.showModal('popup');
    const modalVideo = document.getElementById('modal-video');
    const iframe = modalVideo.querySelector('iframe');

    if (popupModal) {
      const popupContainer = popupModal.querySelector('.modal__container');
      const popupHash = popupModal.dataset.hash;
      Cookies.set('hide-popup', popupHash, { expires: 7 });

      // force scroll top
      if (popupContainer) {
        popupContainer.scrollTop = 0;
      }
    }

    if (videoModalLink) {
      videoModalLink.forEach(function (trigger) {
        trigger.addEventListener('click', function(e) {
          const modalId = trigger.dataset.target;
          e.preventDefault();
          Modal.showModal(modalId);
          iframe.src = trigger.dataset.video;
        });
      });
    }
  }

  static showModal(id) {
    const modal = document.getElementById(id);
    const modalVideo = document.querySelector('.modal--video');
    const modalOverlay = modalVideo.querySelector('.modal__overlay');
    const iframe = modalVideo.querySelector('iframe');

    if (!modal) return;

    const modalClose = modal.querySelector('button[data-micromodal-close]');

    if (modalClose) {
      modalClose.addEventListener('mouseenter', () => window.cursor.enter(false, false));
      modalClose.addEventListener('mouseleave', () => window.cursor.leave());
    }

    MicroModal.show(id, {

      onShow: () => {
        document.body.classList.add('modal-open');
        if (modalVideo) {
          iframe.src = '';
          const posttype = modalOverlay.dataset.type ? modalOverlay.dataset.type : null;
          // when out of iframe, we propose to close,when in we hide the label and cursor
          iframe.addEventListener('mouseenter', () => window.cursor.enter(false, true, true));
          iframe.addEventListener('mouseleave', () => window.cursor.leave(posttype, true));
        }
      },
      onClose: () => {
        const posttype = modalOverlay.dataset.type ? modalOverlay.dataset.type : null;
        document.body.classList.remove('modal-open');

        // if video, we remove src to stop it and remove cursor highlight anf label
        if (modalVideo) {
          modal.addEventListener('mouseleave', () => window.cursor.leave(posttype, false));
          iframe.src = '';
        }
      },
      awaitCloseAnimation: true
    });


    return modal;
  }
}

export default Modal;
